export const asyncStatuses = {
    LOADING: "LOADING",
    SUCCESS: "SUCCESS",
    FAILED: "FAILED"
}